
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__getValidation, StocktakingListId__get_unwrap as StocktakingListId__get_unwrap_1, StocktakingId__get_unwrap as StocktakingId__get_unwrap_1, StocktakingListId, FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, ClientApiResponse$1_$reflection, FormState_$reflection, StocktakingListId_$reflection, StocktakingId_$reflection } from "../../Shared/Shared.js";
import { union_type, class_type, string_type, record_type, lambda_type, unit_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { singleton as singleton_1, map as map_1, isEmpty, empty as empty_1, choose, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { StocktakingListId__get_unwrap, StocktakingId__get_unwrap } from "../../Shared/Shared.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { StocktakingEmailLinkState__ToI18nString, StocktakingEmailLinkState__get_Timestamp } from "../../Shared/Stocktaking.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InformationAlert, ErrorAlert, WarningAlert } from "../../Components/Alert.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TextButton } from "../../Components/Button.js";
import Send_Email from "../../../public/assets/icons/Send_Email.svg";
import Arrow_Right_3 from "../../../public/assets/icons/Arrow_Right_3.svg";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";

class State extends Record {
    constructor(StocktakingId, StocktakingListId, FormState, OnClose, OnResent) {
        super();
        this.StocktakingId = StocktakingId;
        this.StocktakingListId = StocktakingListId;
        this.FormState = FormState;
        this.OnClose = OnClose;
        this.OnResent = OnResent;
    }
}

function State_$reflection() {
    return record_type("Stocktaking.Dialog.StocktakingEmailLinkDialog.State", [], State, () => [["StocktakingId", StocktakingId_$reflection()], ["StocktakingListId", StocktakingListId_$reflection()], ["FormState", FormState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)], ["OnResent", lambda_type(unit_type, unit_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Resend", "Resent", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Stocktaking.Dialog.StocktakingEmailLinkDialog.Msg", [], Msg, () => [[["receiverId", string_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function init(stocktakingId, stocktakingListId, onClose, onResent) {
    return [new State(stocktakingId, stocktakingListId, FormState_get_empty(), onClose, onResent), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.StocktakingId, state.StocktakingListId, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.OnClose, state.OnResent), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.StocktakingId, state.StocktakingListId, FormState_get_empty(), state.OnClose, state.OnResent), Cmd_batch(ofArray([Cmd_successToast("stocktaking.email_link.resend_success"), Cmd_ofEffect((_arg) => {
                    state.OnResent();
                })]))];
            }
        }
        case 2:
            return [new State(state.StocktakingId, state.StocktakingListId, FormState_get_empty(), state.OnClose, state.OnResent), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(state.StocktakingId, state.StocktakingListId, FormState__startLoading(state.FormState), state.OnClose, state.OnResent), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [`/api/stocktakings/${StocktakingId__get_unwrap(state.StocktakingId)}/lists/${StocktakingListId__get_unwrap(state.StocktakingListId)}/email-link/${msg.fields[0]}/resend`, defaultOf()], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
    }
}

export function linkStateLabel(t, state) {
    const matchValue = StocktakingEmailLinkState__get_Timestamp(state);
    if (matchValue == null) {
        return t(StocktakingEmailLinkState__ToI18nString(state));
    }
    else {
        const timestamp = matchValue;
        return concat(t(StocktakingEmailLinkState__ToI18nString(state)), " (", toString(toLocalTime(timestamp), "dd.MM.yyyy HH:mm"), ...")");
    }
}

function HelperRow(props) {
    let elems_2;
    const t = useTranslation()[0];
    const testId = concat("stocktaking-email-link-", ...props.Helper.Id);
    let canResend;
    const matchValue = props.Link.State;
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4: {
            canResend = true;
            break;
        }
        default:
            canResend = false;
    }
    return reactElement("div", createObj(ofArray([["data-test-id", testId], ["className", join(" ", ["flex", "flex-col", "gap-2", "py-3", "border-b", "border-border"])], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
        "data-test-id": concat(testId, ..."-name"),
        className: join(" ", ["font-semibold"]),
        children: props.Helper.Name,
    })), delay(() => append(singleton(reactElement("div", {
        "data-test-id": concat(testId, ..."-email"),
        className: join(" ", ["text-sm", "text-text-muted"]),
        children: concat(t("stocktaking.email_link.email"), ": ", ...props.Link.Email),
    })), delay(() => append(singleton(reactElement("div", {
        "data-test-id": concat(testId, ..."-state"),
        className: join(" ", toList(delay(() => append(singleton("text-sm"), delay(() => {
            const matchValue_1 = props.Link.State;
            switch (matchValue_1.tag) {
                case 5:
                    return singleton("text-primary");
                case 0:
                case 2:
                case 3:
                case 4:
                    return singleton("text-text");
                default:
                    return singleton("text-red");
            }
        }))))),
        children: concat(t("stocktaking.email_link.link_state"), ": ", ...linkStateLabel(t, props.Link.State)),
    })), delay(() => {
        let elems;
        return append((props.Link.State.tag === 1) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", concat(testId, ..."-send-error")], (elems = [createElement(WarningAlert, {
            Label: "stocktaking.email_link.send_error_hint",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(defaultOf_1()), delay(() => {
            let elems_1;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-5"])], (elems_1 = toList(delay(() => {
                let Label;
                return append(canResend ? singleton(createElement(TextButton, (Label = t("stocktaking.email_link.resend"), {
                    ComponentState: props.ComponentState,
                    Icon: Send_Email(),
                    Label: Label,
                    OnClick: () => {
                        props.Dispatch(new Msg(0, [props.Helper.Id]));
                    },
                    TestId: concat(testId, ..."-resend"),
                    Variant: "default",
                }))) : empty(), delay(() => {
                    let Label_1;
                    return singleton(createElement(TextButton, (Label_1 = t("stocktaking.email_link.open_employee"), {
                        ComponentState: props.ComponentState,
                        Icon: Arrow_Right_3(),
                        Label: Label_1,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", "employees", props.Helper.Id]), 1, 1);
                        },
                        TestId: concat(testId, ..."-open-employee"),
                        Variant: "muted",
                    })));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function StocktakingEmailLinkDialog(props) {
    let Title, elems_2;
    const t = useTranslation()[0];
    const stocktakingListId = defaultArg(map((_arg) => _arg.Id, props.StocktakingList), new StocktakingListId("00000000-0000-0000-0000-000000000000"));
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.StocktakingId, stocktakingListId, props.OnClose, props.OnResent), update, (_arg_2, _arg_1_1) => {
    }), undefined, [StocktakingId__get_unwrap_1(props.StocktakingId), StocktakingListId__get_unwrap_1(stocktakingListId)]);
    const state_1 = patternInput_1[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const emailHelpers = choose((helper) => {
        const matchValue = helper.CountingMode;
        if (matchValue.tag === 0) {
            return undefined;
        }
        else {
            return [helper, matchValue.fields[0]];
        }
    }, defaultArg(map((_arg_3) => _arg_3.Helper, props.StocktakingList), empty_1()));
    return createElement(Dialog, (Title = t("stocktaking.email_link.dialog_title"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-email-link-dialog"], ["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: t("stocktaking.email_link.dialog_description"),
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = FormState__getValidation(state_1.FormState, t, "global"), (matchValue_1 == null) ? singleton(defaultOf_1()) : singleton(createElement(ErrorAlert, {
                Label: matchValue_1,
            }))), delay(() => {
                let elems_1;
                return isEmpty(emailHelpers) ? singleton(createElement(InformationAlert, {
                    Label: "stocktaking.email_link.no_email_helpers",
                })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = map_1((tupledArg) => {
                    let elems;
                    const helper_1 = tupledArg[0];
                    return reactElement("div", createObj(ofArray([["key", helper_1.Id], (elems = [createElement(HelperRow, {
                        ComponentState: componentState,
                        Dispatch: patternInput_1[1],
                        Helper: helper_1,
                        Link: tupledArg[1],
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
                }, emailHelpers), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
        Controls: singleton_1(createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.close"),
            OnClick: props.OnClose,
            TestId: "close-stocktaking-email-link-dialog",
            Variant: "blueButton",
        })),
        IsOpen: props.StocktakingList != null,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

